import ComAppTopTip from './AppTip/AppTopTip.vue'
import ComWaiting from './Waitting/waiting.vue'
import ComBackIcon from './BackIcon/index.vue'
import ComToast from './com_toast'


var components = {
  install: function(Vue){
    Vue.component('ComAppTopTip',ComAppTopTip)
    Vue.component('ComWaiting',ComWaiting)
    Vue.component('ComBackIcon',ComBackIcon)
    Vue.component('ComToast',ComToast)
  }
}

export default components



// WEBPACK FOOTER //
// ./src/components/index.js